export const formatUSD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatUSDForcedCents = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatNumber = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatPercentage = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatFilesize = (bytes, decimals = 1) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

let notifyOfPhoneFormatLengthIssue = true;

export function formatPhoneNumber(phoneNumber, shouldToast = false) {
  if (!phoneNumber) return "";

  let cleaned = ("" + phoneNumber).replace(/\D/g, "");

  if (cleaned.length > 10 && cleaned[0] !== "1" && notifyOfPhoneFormatLengthIssue && shouldToast) {
    notifyOfPhoneFormatLengthIssue = false;
    toast.warning("Double check your phone number – you may have entered too many digits. We only allow US phone numbers.");
    setTimeout(() => notifyOfPhoneFormatLengthIssue = true, 1000);
  }

  const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    cleaned = `${match[1] ? "(" : ""}${match[1]}${match[2] ? ") " : ""}${match[2]}${match[3] ? "-" : ""}${match[3]}`;
  } else {
    const match = cleaned.slice(-10).match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      cleaned = "+" + cleaned.slice(0, cleaned.length - 10) + " " + `${match[1] ? "(" : ""}${match[1]}${match[2] ? ") " : ""}${match[2]}${match[3] ? "-" : ""}${match[3]}`;
    }
  }
  return cleaned;
}

export const format = (value, type, shouldToast =false) => {
  switch (type) {
  case "number":
    return formatNumber.format(value);
  case "percentage":
    return formatPercentage.format(value ? value / 100 : 0);
  case "usd":
    return formatUSD.format(value);
  case "usd-force-cents":
    return formatUSDForcedCents.format(value);
  case "phone":
    return formatPhoneNumber(value, shouldToast);
  case "date":
    if (!value) return "";
    return new Date(value).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  case "datetime":
    if (!value) return "";
    return new Date(value).toLocaleString("en-US", {
      year: "2-digit",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
  case "filesize":
    return formatFilesize(value);
  case "hex":
    if (!value) return "#";
    return "#" + value.replace(/[^a-fA-F0-9]/g, "");
  case "username":
    if (!value) return "@";
    return "@" + value.toLowerCase();
  case "integer":
    if (!value) return 0;
    return parseInt(value);
  default:
    return value;
  }
};

export const minutesHoursToReadableTimeLong = (minutes = 0) => {
  if (!minutes) return "0 minutes";
  const hours = Math.floor(minutes / 60);
  const minutesRemainder = minutes % 60;
  let timeString = "";
  if (hours > 0) timeString += hours + " hour" + (hours > 1 ? "s" : "") + " ";
  if (minutesRemainder > 0) timeString += minutesRemainder + " minute" + (minutesRemainder > 1 ? "s" : "");

  return timeString;
};

export const minutesToReadableTime = (minutes) => {
  const units = [
    {name: "minute", duration: 60},
    {name: "hour", duration: 24},
    {name: "day", duration: 7},
    {name: "week", duration: 4.3482},
    {name: "month", duration: 12},
    {name: "year", duration: Infinity}
  ];

  for (let i = 0; i < units.length; i++) {
    if (minutes < units[i].duration) {
      const timeValue = Math.floor(minutes);
      return timeValue + " " + units[i].name + (timeValue !== 1 ? "s" : "");
    }

    minutes /= units[i].duration;
  }
};
